import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand } from '@fortawesome/free-solid-svg-icons';
import {
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
} from '@awesome.me/kit-eb69e755a9/icons/sharp/regular';
import { GraphToolbarButton } from './GraphToolbarButton';

const ZOOM_FACTOR = 1;

export enum GraphZoomType {
    In = 'in',
    Out = 'out',
    All = 'all',
}

export interface GraphZoomController {
    zoom: {
        zoom: {
            scaleBy: (transition: unknown, factor: number) => void;
        };
        zoomTransition: () => unknown;
        resetZoom: () => void;
    };
}

interface Props {
    graph: GraphZoomController;
}

const GRAPH_ZOOM_ICON_MAP = {
    [GraphZoomType.In]: faMagnifyingGlassPlus,
    [GraphZoomType.Out]: faMagnifyingGlassMinus,
    [GraphZoomType.All]: faExpand,
} as const;

const GRAPH_ZOOM_LABEL_MAP: Record<GraphZoomType, () => string> = {
    [GraphZoomType.In]: () => gettext('GRAPH_ZOOM_IN'),
    [GraphZoomType.Out]: () => gettext('GRAPH_ZOOM_OUT'),
    [GraphZoomType.All]: () => gettext('GRAPH_ZOOM_ALL'),
};

const GRAPH_ZOOM_TYPES: GraphZoomType[] = Object.values(GraphZoomType);

export function GraphZoomButtons({ graph }: Props): JSX.Element {
    function scaleBy(factor: number) {
        graph.zoom.zoom.scaleBy(graph.zoom.zoomTransition(), factor);
    }

    function onZoom(type: GraphZoomType) {
        switch (type) {
            case GraphZoomType.In:
                scaleBy(1 + ZOOM_FACTOR);
                break;
            case GraphZoomType.Out:
                scaleBy(1 / (1 + ZOOM_FACTOR));
                break;
            case GraphZoomType.All:
                graph.zoom.resetZoom();
                break;
            default:
                throw new Error('Unknown graph zoom type.');
        }
    }

    return (
        <>
            {GRAPH_ZOOM_TYPES.map((type) => (
                <GraphToolbarButton
                    key={type}
                    ariaLabel={GRAPH_ZOOM_LABEL_MAP[type]()}
                    onClick={() => {
                        onZoom(type);
                    }}
                >
                    <FontAwesomeIcon icon={GRAPH_ZOOM_ICON_MAP[type]} className="h-6 w-6" />
                </GraphToolbarButton>
            ))}
        </>
    );
}
